import Legalese from './legalese';
import Directory from './directory/directory';
import MailingList from './mailing-list';

interface FooterProps {
  showLegalese?: boolean;
  showMailingList?: boolean;
  showSignUpSuccess?: boolean;
  HEROKU_RELEASE_VERSION?: string;
  osanoEnabled?: boolean;
}

export default function LiveLargeFooter({
  showLegalese,
  showMailingList,
  showSignUpSuccess,
  HEROKU_RELEASE_VERSION,
  osanoEnabled,
}: FooterProps) {
  return (
    <div className="flex w-full items-center justify-center">
      <div className="flex w-full max-w-[1440px] flex-col items-center justify-center gap-[88px] px-[24px] py-[24px] md:px-[48px]">
        {showLegalese ? <Legalese /> : null}

        {showMailingList ? <MailingList showSignUpSuccess={showSignUpSuccess} /> : null}

        <Directory
          HEROKU_RELEASE_VERSION={HEROKU_RELEASE_VERSION}
          osanoEnabled={osanoEnabled}
        />
      </div>
    </div>
  );
}
